import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function CookiePolicy() {
  return <ComingSoon title="Cookie Policy" />;
}
